/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createSite = /* GraphQL */ `
  mutation CreateSite(
    $input: CreateSiteInput!
    $condition: ModelSiteConditionInput
  ) {
    createSite(input: $input, condition: $condition) {
      id
      csid
      name
      description
      latitude
      longitude
      geohash
      address
      customer_name
      cameras {
        items {
          id
          camera_asset_id
          name
          latitude
          longitude
          geohash
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          http_stream
          video_gateway
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      routes {
        items {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      checkpoints {
        items {
          id
          name
          description
          checklist
          site_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          camera_id
          camera {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSite = /* GraphQL */ `
  mutation UpdateSite(
    $input: UpdateSiteInput!
    $condition: ModelSiteConditionInput
  ) {
    updateSite(input: $input, condition: $condition) {
      id
      csid
      name
      description
      latitude
      longitude
      geohash
      address
      customer_name
      cameras {
        items {
          id
          camera_asset_id
          name
          latitude
          longitude
          geohash
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          http_stream
          video_gateway
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      routes {
        items {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      checkpoints {
        items {
          id
          name
          description
          checklist
          site_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          camera_id
          camera {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSite = /* GraphQL */ `
  mutation DeleteSite(
    $input: DeleteSiteInput!
    $condition: ModelSiteConditionInput
  ) {
    deleteSite(input: $input, condition: $condition) {
      id
      csid
      name
      description
      latitude
      longitude
      geohash
      address
      customer_name
      cameras {
        items {
          id
          camera_asset_id
          name
          latitude
          longitude
          geohash
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          http_stream
          video_gateway
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      routes {
        items {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      checkpoints {
        items {
          id
          name
          description
          checklist
          site_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          camera_id
          camera {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCamera = /* GraphQL */ `
  mutation CreateCamera(
    $input: CreateCameraInput!
    $condition: ModelCameraConditionInput
  ) {
    createCamera(input: $input, condition: $condition) {
      id
      camera_asset_id
      name
      latitude
      longitude
      geohash
      site {
        id
        csid
        name
        description
        latitude
        longitude
        geohash
        address
        customer_name
        cameras {
          items {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      site_id
      checkpoints {
        items {
          id
          name
          description
          checklist
          site_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          camera_id
          camera {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      http_stream
      video_gateway
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCamera = /* GraphQL */ `
  mutation UpdateCamera(
    $input: UpdateCameraInput!
    $condition: ModelCameraConditionInput
  ) {
    updateCamera(input: $input, condition: $condition) {
      id
      camera_asset_id
      name
      latitude
      longitude
      geohash
      site {
        id
        csid
        name
        description
        latitude
        longitude
        geohash
        address
        customer_name
        cameras {
          items {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      site_id
      checkpoints {
        items {
          id
          name
          description
          checklist
          site_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          camera_id
          camera {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      http_stream
      video_gateway
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCamera = /* GraphQL */ `
  mutation DeleteCamera(
    $input: DeleteCameraInput!
    $condition: ModelCameraConditionInput
  ) {
    deleteCamera(input: $input, condition: $condition) {
      id
      camera_asset_id
      name
      latitude
      longitude
      geohash
      site {
        id
        csid
        name
        description
        latitude
        longitude
        geohash
        address
        customer_name
        cameras {
          items {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      site_id
      checkpoints {
        items {
          id
          name
          description
          checklist
          site_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          camera_id
          camera {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      http_stream
      video_gateway
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createIncidentType = /* GraphQL */ `
  mutation CreateIncidentType(
    $input: CreateIncidentTypeInput!
    $condition: ModelIncidentTypeConditionInput
  ) {
    createIncidentType(input: $input, condition: $condition) {
      id
      name
      checkpoint_records {
        items {
          id
          order
          record_id
          record {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          checkpoint_id
          checkpoint {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          incident_type_id
          incident_type {
            id
            name
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          checklist_results
          completed_at
          image_url
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateIncidentType = /* GraphQL */ `
  mutation UpdateIncidentType(
    $input: UpdateIncidentTypeInput!
    $condition: ModelIncidentTypeConditionInput
  ) {
    updateIncidentType(input: $input, condition: $condition) {
      id
      name
      checkpoint_records {
        items {
          id
          order
          record_id
          record {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          checkpoint_id
          checkpoint {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          incident_type_id
          incident_type {
            id
            name
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          checklist_results
          completed_at
          image_url
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteIncidentType = /* GraphQL */ `
  mutation DeleteIncidentType(
    $input: DeleteIncidentTypeInput!
    $condition: ModelIncidentTypeConditionInput
  ) {
    deleteIncidentType(input: $input, condition: $condition) {
      id
      name
      checkpoint_records {
        items {
          id
          order
          record_id
          record {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          checkpoint_id
          checkpoint {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          incident_type_id
          incident_type {
            id
            name
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          checklist_results
          completed_at
          image_url
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRoute = /* GraphQL */ `
  mutation CreateRoute(
    $input: CreateRouteInput!
    $condition: ModelRouteConditionInput
  ) {
    createRoute(input: $input, condition: $condition) {
      id
      name
      route_type {
        id
        name
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      route_type_id
      site {
        id
        csid
        name
        description
        latitude
        longitude
        geohash
        address
        customer_name
        cameras {
          items {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      site_id
      schedules {
        items {
          id
          route_id
          route {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          operator_ids
          cron_expression
          deleted
          deletedAt
          records {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          patrols {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              completed
              operator_ids
              datetime
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      route_checkpoints {
        items {
          id
          route_id
          checkpoint_id
          order
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRoute = /* GraphQL */ `
  mutation UpdateRoute(
    $input: UpdateRouteInput!
    $condition: ModelRouteConditionInput
  ) {
    updateRoute(input: $input, condition: $condition) {
      id
      name
      route_type {
        id
        name
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      route_type_id
      site {
        id
        csid
        name
        description
        latitude
        longitude
        geohash
        address
        customer_name
        cameras {
          items {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      site_id
      schedules {
        items {
          id
          route_id
          route {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          operator_ids
          cron_expression
          deleted
          deletedAt
          records {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          patrols {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              completed
              operator_ids
              datetime
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      route_checkpoints {
        items {
          id
          route_id
          checkpoint_id
          order
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRoute = /* GraphQL */ `
  mutation DeleteRoute(
    $input: DeleteRouteInput!
    $condition: ModelRouteConditionInput
  ) {
    deleteRoute(input: $input, condition: $condition) {
      id
      name
      route_type {
        id
        name
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      route_type_id
      site {
        id
        csid
        name
        description
        latitude
        longitude
        geohash
        address
        customer_name
        cameras {
          items {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      site_id
      schedules {
        items {
          id
          route_id
          route {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          operator_ids
          cron_expression
          deleted
          deletedAt
          records {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          patrols {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              completed
              operator_ids
              datetime
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      route_checkpoints {
        items {
          id
          route_id
          checkpoint_id
          order
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRouteType = /* GraphQL */ `
  mutation CreateRouteType(
    $input: CreateRouteTypeInput!
    $condition: ModelRouteTypeConditionInput
  ) {
    createRouteType(input: $input, condition: $condition) {
      id
      name
      routes {
        items {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRouteType = /* GraphQL */ `
  mutation UpdateRouteType(
    $input: UpdateRouteTypeInput!
    $condition: ModelRouteTypeConditionInput
  ) {
    updateRouteType(input: $input, condition: $condition) {
      id
      name
      routes {
        items {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRouteType = /* GraphQL */ `
  mutation DeleteRouteType(
    $input: DeleteRouteTypeInput!
    $condition: ModelRouteTypeConditionInput
  ) {
    deleteRouteType(input: $input, condition: $condition) {
      id
      name
      routes {
        items {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRouteCheckPoints = /* GraphQL */ `
  mutation CreateRouteCheckPoints(
    $input: CreateRouteCheckPointsInput!
    $condition: ModelRouteCheckPointsConditionInput
  ) {
    createRouteCheckPoints(input: $input, condition: $condition) {
      id
      route_id
      checkpoint_id
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRouteCheckPoints = /* GraphQL */ `
  mutation UpdateRouteCheckPoints(
    $input: UpdateRouteCheckPointsInput!
    $condition: ModelRouteCheckPointsConditionInput
  ) {
    updateRouteCheckPoints(input: $input, condition: $condition) {
      id
      route_id
      checkpoint_id
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRouteCheckPoints = /* GraphQL */ `
  mutation DeleteRouteCheckPoints(
    $input: DeleteRouteCheckPointsInput!
    $condition: ModelRouteCheckPointsConditionInput
  ) {
    deleteRouteCheckPoints(input: $input, condition: $condition) {
      id
      route_id
      checkpoint_id
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCheckpoint = /* GraphQL */ `
  mutation CreateCheckpoint(
    $input: CreateCheckpointInput!
    $condition: ModelCheckpointConditionInput
  ) {
    createCheckpoint(input: $input, condition: $condition) {
      id
      name
      description
      checklist
      site_id
      site {
        id
        csid
        name
        description
        latitude
        longitude
        geohash
        address
        customer_name
        cameras {
          items {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      camera_id
      camera {
        id
        camera_asset_id
        name
        latitude
        longitude
        geohash
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        site_id
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        http_stream
        video_gateway
        createdAt
        updatedAt
        __typename
      }
      route_checkpoints {
        items {
          id
          route_id
          checkpoint_id
          order
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      checkpoint_records {
        items {
          id
          order
          record_id
          record {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          checkpoint_id
          checkpoint {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          incident_type_id
          incident_type {
            id
            name
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          checklist_results
          completed_at
          image_url
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCheckpoint = /* GraphQL */ `
  mutation UpdateCheckpoint(
    $input: UpdateCheckpointInput!
    $condition: ModelCheckpointConditionInput
  ) {
    updateCheckpoint(input: $input, condition: $condition) {
      id
      name
      description
      checklist
      site_id
      site {
        id
        csid
        name
        description
        latitude
        longitude
        geohash
        address
        customer_name
        cameras {
          items {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      camera_id
      camera {
        id
        camera_asset_id
        name
        latitude
        longitude
        geohash
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        site_id
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        http_stream
        video_gateway
        createdAt
        updatedAt
        __typename
      }
      route_checkpoints {
        items {
          id
          route_id
          checkpoint_id
          order
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      checkpoint_records {
        items {
          id
          order
          record_id
          record {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          checkpoint_id
          checkpoint {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          incident_type_id
          incident_type {
            id
            name
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          checklist_results
          completed_at
          image_url
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCheckpoint = /* GraphQL */ `
  mutation DeleteCheckpoint(
    $input: DeleteCheckpointInput!
    $condition: ModelCheckpointConditionInput
  ) {
    deleteCheckpoint(input: $input, condition: $condition) {
      id
      name
      description
      checklist
      site_id
      site {
        id
        csid
        name
        description
        latitude
        longitude
        geohash
        address
        customer_name
        cameras {
          items {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      camera_id
      camera {
        id
        camera_asset_id
        name
        latitude
        longitude
        geohash
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        site_id
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        http_stream
        video_gateway
        createdAt
        updatedAt
        __typename
      }
      route_checkpoints {
        items {
          id
          route_id
          checkpoint_id
          order
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      checkpoint_records {
        items {
          id
          order
          record_id
          record {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          checkpoint_id
          checkpoint {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          incident_type_id
          incident_type {
            id
            name
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          checklist_results
          completed_at
          image_url
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSchedule = /* GraphQL */ `
  mutation CreateSchedule(
    $input: CreateScheduleInput!
    $condition: ModelScheduleConditionInput
  ) {
    createSchedule(input: $input, condition: $condition) {
      id
      route_id
      route {
        id
        name
        route_type {
          id
          name
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        route_type_id
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        site_id
        schedules {
          items {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      operator_ids
      cron_expression
      deleted
      deletedAt
      records {
        items {
          id
          schedule_id
          schedule {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          report_url
          operator_id
          start_time
          end_time
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      patrols {
        items {
          id
          schedule_id
          schedule {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          completed
          operator_ids
          datetime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSchedule = /* GraphQL */ `
  mutation UpdateSchedule(
    $input: UpdateScheduleInput!
    $condition: ModelScheduleConditionInput
  ) {
    updateSchedule(input: $input, condition: $condition) {
      id
      route_id
      route {
        id
        name
        route_type {
          id
          name
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        route_type_id
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        site_id
        schedules {
          items {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      operator_ids
      cron_expression
      deleted
      deletedAt
      records {
        items {
          id
          schedule_id
          schedule {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          report_url
          operator_id
          start_time
          end_time
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      patrols {
        items {
          id
          schedule_id
          schedule {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          completed
          operator_ids
          datetime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSchedule = /* GraphQL */ `
  mutation DeleteSchedule(
    $input: DeleteScheduleInput!
    $condition: ModelScheduleConditionInput
  ) {
    deleteSchedule(input: $input, condition: $condition) {
      id
      route_id
      route {
        id
        name
        route_type {
          id
          name
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        route_type_id
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        site_id
        schedules {
          items {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      operator_ids
      cron_expression
      deleted
      deletedAt
      records {
        items {
          id
          schedule_id
          schedule {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          report_url
          operator_id
          start_time
          end_time
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      patrols {
        items {
          id
          schedule_id
          schedule {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          completed
          operator_ids
          datetime
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPatrol = /* GraphQL */ `
  mutation CreatePatrol(
    $input: CreatePatrolInput!
    $condition: ModelPatrolConditionInput
  ) {
    createPatrol(input: $input, condition: $condition) {
      id
      schedule_id
      schedule {
        id
        route_id
        route {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        operator_ids
        cron_expression
        deleted
        deletedAt
        records {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        patrols {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            completed
            operator_ids
            datetime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      completed
      operator_ids
      datetime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePatrol = /* GraphQL */ `
  mutation UpdatePatrol(
    $input: UpdatePatrolInput!
    $condition: ModelPatrolConditionInput
  ) {
    updatePatrol(input: $input, condition: $condition) {
      id
      schedule_id
      schedule {
        id
        route_id
        route {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        operator_ids
        cron_expression
        deleted
        deletedAt
        records {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        patrols {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            completed
            operator_ids
            datetime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      completed
      operator_ids
      datetime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePatrol = /* GraphQL */ `
  mutation DeletePatrol(
    $input: DeletePatrolInput!
    $condition: ModelPatrolConditionInput
  ) {
    deletePatrol(input: $input, condition: $condition) {
      id
      schedule_id
      schedule {
        id
        route_id
        route {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        operator_ids
        cron_expression
        deleted
        deletedAt
        records {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        patrols {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            completed
            operator_ids
            datetime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      completed
      operator_ids
      datetime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRecord = /* GraphQL */ `
  mutation CreateRecord(
    $input: CreateRecordInput!
    $condition: ModelRecordConditionInput
  ) {
    createRecord(input: $input, condition: $condition) {
      id
      schedule_id
      schedule {
        id
        route_id
        route {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        operator_ids
        cron_expression
        deleted
        deletedAt
        records {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        patrols {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            completed
            operator_ids
            datetime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      report_url
      operator_id
      start_time
      end_time
      checkpoint_records {
        items {
          id
          order
          record_id
          record {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          checkpoint_id
          checkpoint {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          incident_type_id
          incident_type {
            id
            name
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          checklist_results
          completed_at
          image_url
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRecord = /* GraphQL */ `
  mutation UpdateRecord(
    $input: UpdateRecordInput!
    $condition: ModelRecordConditionInput
  ) {
    updateRecord(input: $input, condition: $condition) {
      id
      schedule_id
      schedule {
        id
        route_id
        route {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        operator_ids
        cron_expression
        deleted
        deletedAt
        records {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        patrols {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            completed
            operator_ids
            datetime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      report_url
      operator_id
      start_time
      end_time
      checkpoint_records {
        items {
          id
          order
          record_id
          record {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          checkpoint_id
          checkpoint {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          incident_type_id
          incident_type {
            id
            name
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          checklist_results
          completed_at
          image_url
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRecord = /* GraphQL */ `
  mutation DeleteRecord(
    $input: DeleteRecordInput!
    $condition: ModelRecordConditionInput
  ) {
    deleteRecord(input: $input, condition: $condition) {
      id
      schedule_id
      schedule {
        id
        route_id
        route {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        operator_ids
        cron_expression
        deleted
        deletedAt
        records {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        patrols {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            completed
            operator_ids
            datetime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      report_url
      operator_id
      start_time
      end_time
      checkpoint_records {
        items {
          id
          order
          record_id
          record {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          checkpoint_id
          checkpoint {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          incident_type_id
          incident_type {
            id
            name
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          checklist_results
          completed_at
          image_url
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCheckpointRecord = /* GraphQL */ `
  mutation CreateCheckpointRecord(
    $input: CreateCheckpointRecordInput!
    $condition: ModelCheckpointRecordConditionInput
  ) {
    createCheckpointRecord(input: $input, condition: $condition) {
      id
      order
      record_id
      record {
        id
        schedule_id
        schedule {
          id
          route_id
          route {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          operator_ids
          cron_expression
          deleted
          deletedAt
          records {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          patrols {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              completed
              operator_ids
              datetime
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        report_url
        operator_id
        start_time
        end_time
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      checkpoint_id
      checkpoint {
        id
        name
        description
        checklist
        site_id
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        camera_id
        camera {
          id
          camera_asset_id
          name
          latitude
          longitude
          geohash
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          http_stream
          video_gateway
          createdAt
          updatedAt
          __typename
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      incident_type_id
      incident_type {
        id
        name
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      checklist_results
      completed_at
      image_url
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCheckpointRecord = /* GraphQL */ `
  mutation UpdateCheckpointRecord(
    $input: UpdateCheckpointRecordInput!
    $condition: ModelCheckpointRecordConditionInput
  ) {
    updateCheckpointRecord(input: $input, condition: $condition) {
      id
      order
      record_id
      record {
        id
        schedule_id
        schedule {
          id
          route_id
          route {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          operator_ids
          cron_expression
          deleted
          deletedAt
          records {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          patrols {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              completed
              operator_ids
              datetime
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        report_url
        operator_id
        start_time
        end_time
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      checkpoint_id
      checkpoint {
        id
        name
        description
        checklist
        site_id
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        camera_id
        camera {
          id
          camera_asset_id
          name
          latitude
          longitude
          geohash
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          http_stream
          video_gateway
          createdAt
          updatedAt
          __typename
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      incident_type_id
      incident_type {
        id
        name
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      checklist_results
      completed_at
      image_url
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCheckpointRecord = /* GraphQL */ `
  mutation DeleteCheckpointRecord(
    $input: DeleteCheckpointRecordInput!
    $condition: ModelCheckpointRecordConditionInput
  ) {
    deleteCheckpointRecord(input: $input, condition: $condition) {
      id
      order
      record_id
      record {
        id
        schedule_id
        schedule {
          id
          route_id
          route {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          operator_ids
          cron_expression
          deleted
          deletedAt
          records {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          patrols {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              completed
              operator_ids
              datetime
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        report_url
        operator_id
        start_time
        end_time
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      checkpoint_id
      checkpoint {
        id
        name
        description
        checklist
        site_id
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        camera_id
        camera {
          id
          camera_asset_id
          name
          latitude
          longitude
          geohash
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          http_stream
          video_gateway
          createdAt
          updatedAt
          __typename
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      incident_type_id
      incident_type {
        id
        name
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      checklist_results
      completed_at
      image_url
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
